import React, { useState } from "react";
import "./Roofrepair.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר



export default function Abseiling_sealing() {



  return (

    <div className="Roofrepair-page">
      <div className="Roofrepair-hero">
        <div className="Roofrepair-overlay">
          <h1>       איטום בסנפלינג  </h1>
        </div>
<div>
</div>
</div>
    <div className="page3">
 <div className="breadcrumb3">
  <Link to="/">בית</Link> /{" "}
  <Link to="/ProfessionalInformation"> מידע מקצועי</Link>/{" "}
   <Link to="/Working_at_Height">    עבודה בגובה</Link>/{" "}
    <Link to="/Abseiling_sealing">      איטום בסנפלינג    </Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page4">
  <div className="container">

    <h2 className="top-text">
מתי כדאי לבצע עבודות איטום בסנפלינג, ומתי כדאי לבצע עבודות איטום רגילות? כאשר אוטמים גג רגיל, אפשר להניח את היריעות, או למרוח את החומר על הגג ללא סנפלינג. אולם, לפעמים, יהיה צורך לרדת קצת בסנפלינג, ולמתוח את היריעות, או למרוח את החומר על דפנות הבניין. אילו עבודות איטום מתאים לבצע באמצעות סנפלינג?
    </h2>
      
    <div className="content-row">

      <div className="image-box">
        <img src="/images/64.jpg" alt="roof" />
      </div>
      <div className="text-box">
           <h2 className="main-title">
איטום קירות חיצוניים של בניין:
    </h2>
        <p> בבניינים ישנים רבים, יש צורך לפעמים בציפוי חיצוני של קיר הבניין בחומר איטום. לפעמים, יהיה צורך למרוח את הקיר בחומר איטום. לפעמים, יהיה צורך להדביק גם יריעות. איטום של קיר חיצוני, עדיף לבצע באמצעות סנפלינג. העובד, מחבר את הבסיס אל הגג, משלשל לאט את החבל, ויורד בהדרגה, תוך כדי ציפוי הקיר באמצעות המברשת.</p>

    <h2 className="main-title">
העובד יורד עם כל הציוד:


    </h2>
        <p>         פעולת איטום בסנפלינג, הינה פעולת איטום מורכבת מאוד. העובד, יורד עם תיק, ועם הציוד. לרוב, עם המברשת והדלי. נדרשת מיומנות אקרובטית כדי לשאת את הדלי והמברשת, ולהצליח למרוח את החומר על הקיר, תוך כדי ירידה.        </p>



      </div>




    </div>

    <h2 className="main-title">
לפעמים- אין גבול לגובה הנדרש:



    </h2>

    <div className="bottom-text">
      <p> עבודת איטום וזיפות גגות, יכולה להיעשות בגובה של 2 קומות, ויכולה גם להיעשות מגובה של 4 קומות ומעלה. ככל שהגובה גדול יותר, כך נדרשת מיומנות גבוהה יותר, ועל העובד להיות יותר ויותר מיומן בתחום הסנפלינג. עבודות איטום רבות, ייעשו במבני ציבור בגובה 4-5 קומות של בתי ספר, מבני עירייה ומועצות, ועוד. </p>

    <h2 className="main-title">
איטום גג רעפים:

    </h2>

      <p>פעולת איטום בסנפלינג של גג רעפים, הינה פעולה מאתגרת. בדרך כלל, האוטם יחליף רעפים סדוקות ושבורות, ולאחר מכן יצפה את גג הרעפים בחומר איטום. ישנם חומרי איטום מיוחדים שקופים עבור גג רעפים. החומר נותן לגג הגנה מפני רטיבות, אך הינו שקוף, ולא פוגע בצבע האדום של הגג. בדרך כלל, העובד יסתמך על חבל הסנפלינג, אך גם ילך על גג הרעפים.

</p>

    <h2 className="main-title">
ציפוי חיצוני של קירות מבני מכולה:

    </h2>

      <p>   מבנים רבים, עשויים ממכולת ברזל. מכולות אלו, שימשו לאכסון, או היוו פתרון נוח של מבנה לא יקר. אזורי תעשייה רבים, מכילים מבנים רבים העשויים ממכולה. לפעמים, היו מחנות צבאיים, או מבני תעשייה צבאית, או שימוש ממשלתי במכולות אלו. כאשר התפנו המכולות ונותרו ללא שימוש, נתנו העיריות והמועצות המקומיות את המכולות למוסדות חינוך. אולמות ספורט רבים של בתי ספר, נמצאות במבני מכולה גדולים. את המבנים הללו מומלץ לצפות בחומר איטום נגד רטיבות. זאת, על מנת שהמבנה לא יתכסה עם השנים בחלודה. את פעולת מריחת חומר האיטום על המכולה, ניתן לבצע בעיקר באמצעות סנפלינג מגג המכולה, ועד לקרקעית.

 
</p>

    </div>


         

     <ContactSection2/>
<div className="links">

  <Link to="/Working_in_abseiling" className="link-right" > עבודה סנפלינג </Link>
  <Link to="/Rain_is_good_but_not_in_doors" className="link-left" >   גשם זה טוב - לא בתוך הבית    </Link>

</div>

      </div>
    </div>
  

      </div>
  );
}

